function Faq() {
    this.init();
}

Faq.prototype.init = function () {
    jQuery('.faq__question').click( function() {
        jQuery(this).siblings('.faq__answer').slideToggle();
        jQuery(this).parent('.faq').toggleClass('open');
    })

    jQuery('.selectblock--faq li').click( function() {

        jQuery('.selectblock__header').removeClass('clicked');
        jQuery('.selectblock__options').removeClass('show');

        var slug = jQuery(this).data('value');
        var text = jQuery(this).text();

        jQuery('.selectblock__header').text(text);

        jQuery('.faq').each(function() {
            if (jQuery(this).hasClass(slug)) {
                jQuery(this).slideDown();
            }
            else {
                jQuery(this).slideUp();
            }
        });



    });
}

export default Faq;



// WEBPACK FOOTER //
// ./js/components/faq/index.js